const defaultProps = {
  schemas: [],
};

function OutputPointer({ field, object, fieldPointer, sourceField }) {
  const sourceFieldName = sourceField || field;
  const pointer = object[sourceFieldName];

  if (fieldPointer && fieldPointer.item && pointer) {
    return pointer[fieldPointer.item] || "";
  }

  if (
    (pointer && field === "employee") ||
    (pointer && field === "selectedSupervisor") ||
    (pointer && field === "assignedEmployee") ||
    (pointer && field === "supervisor") ||
    (pointer && field === "request")
  ) {
    return pointer?.surname
      ? `${pointer?.surname?.toUpperCase() || ""}, ${
          pointer?.Firstname?.toUpperCase() || ""
        } ${pointer?.Middlename?.toUpperCase() || ""}`
      : "";
  } else if (
    pointer &&
    (field === "requestType" ||
      field === "loanType" ||
      field === "area" ||
      field === "device")
  ) {
    return pointer.name;
  } else if (pointer && (field === "position" || field === "positionTitle")) {
    return pointer.position_title;
  } else if (pointer && field === "user") {
    return pointer?.employee?.surname
      ? `${pointer?.employee?.surname?.toUpperCase() || ""}, ${
          pointer?.employee?.Firstname?.toUpperCase() || ""
        } ${pointer?.employee?.Middlename?.toUpperCase() || ""} `
      : "";
  } else if (
    pointer &&
    (field === "employmentType" ||
      field === "employmentTypes" ||
      field === "payItems" ||
      field === "payrollTypes")
  ) {
    return pointer.name;
  } else if (pointer && field === "payCode") {
    return pointer.name;
  } else if (pointer && field === "allowanceType") {
    return pointer.AllowanceType;
  } else if (pointer && field === "accountNumber") {
    return pointer.accountNumber || "";
  }
  return null;
}

OutputPointer.defaultProps = defaultProps;
export default OutputPointer;
